import './Services.css'

const services = [
  {
    title: 'AI Agents',
    description: 'AI agents for your business, built for scale.',
    icon: '🤖'
  },
  {
    title: 'PropTech',
    description: 'Smart property and society management platforms — from gate automation to resident communication.',
    icon: '🏢'
  },
  {
    title: 'Gaming',
    description: 'Real-time engines, multiplayer backends, and immersive digital experiences for the next gen.',
    icon: '🎮'
  },
  {
    title: 'Entertainment',
    description: 'Streaming services, digital rights management, and media distribution pipelines.',
    icon: '▶️'
  },
  {
    title: 'Finance',
    description: 'Secure fintech ecosystems, banking solutions, and automated compliance tools.',
    icon: '📈'
  },
  {
    title: 'Lifestyle',
    description: 'Consumer apps and platforms built around health, wellness, community, and everyday living.',
    icon: '✨'
  },
  {
    title: 'Marketing',
    description: 'Data-driven automation, growth tools, and analytics engines for modern marketers.',
    icon: '📢'
  }
]

const Services = () => {
  return (
    <section id="sectors" className="services section">
      <div className="container">
        <div className="services-header">
          <p className="section-label">SEVEN DOMAINS</p>
          <h2 className="section-title">
            Seven Domains. <span className="highlight-orange">Infinite Possibilities.</span>
          </h2>
          <p className="status-label">(UPCOMING)</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
